import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {IonContent, NavParams} from '@ionic/angular';

import {CustomerModel} from 'src/app/models/customer-model';
import {AuthenticationService} from 'src/app/services/authentication/authentication.service';
import {SuccessMessageService} from 'src/app/services/message-provider/success-message.service';
import {UniqueIDService} from 'src/app/services/unique-id/unique-id.service';
import {
  eMfaStatuses,
  UserSessionService,
} from 'src/app/services/user-session/user-session.service';
import {Navigator} from 'src/app/services/routing/navigator';
import {LogoutService} from 'src/app/services/logout/logout.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'reset-password-mfa',
  templateUrl: './reset-password-mfa.component.html',
  styleUrls: ['./reset-password-mfa.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class ResetPasswordMFAComponent implements OnInit {
  @ViewChild(IonContent, {static: false}) content: IonContent;

  error = null;
  tokenExpired = false;
  verifiedCode: boolean;
  showMessageSMSSent: boolean;
  // customer: CustomerModel;
  channels: string[];
  currentDisplayChannel: string;
  bypassPinSuccessUI = false; // it is by design in some case
  loginUrl;
  tokenURL;
  tokenResponseCompleted : Promise<boolean>;
  @Input() customerId: any;
  @Input() phoneNumber: any;
  @Input() token: any;
  @Input() email:string;

  constructor(
    private navParams: NavParams,
    private userSessionService: UserSessionService,
    private authenticationService: AuthenticationService,
    private uniqueIDService: UniqueIDService,
    private navigator: Navigator,
    private logoutService: LogoutService,
    private configService: ConfigService,
    public successMessageService: SuccessMessageService,
    public utils: UtilsService,
    private cgd:ChangeDetectorRef
  ) {

    this.loginUrl = `${this.configService.getConfig().LOBBY_URL}?r=0#load-dialog=login`;
      //Fetch the Token from navParams logic
      // let holdURL = this.navParams.get('tokenURL');
      // console.log(holdURL)
      // let getQueryString = holdURL.split("?")[1]
      // let token = getQueryString.split('=')[1];
      // this.tokenURL = token.split('#')[0];
      // console.log(this.tokenURL)
      // this.getToken(this.tokenURL);

    const mfaType = this.configService.getConfig().FEATURE_MFA_TYPE;
    const channels = this.configService.getConfig().FEATURE_MFA_CHANNELS as string;
    if(channels) {
      this.channels = channels.replace(/\s/g, '').split(','); //clean spaces in case configuration is not clean
    }
    if(!this.channels || this.channels.length == 0) {
      this.channels = ['SMS']; // default
    }

    if(mfaType && !this.channels.includes(mfaType)) {
      this.channels.push(mfaType);
    }
    this.currentDisplayChannel = mfaType ? mfaType : this.channels?.[0];
  }

  ngOnInit() {
    this.uniqueIDService.removeMFADeviceId();
    // this.successMessageService.clearMessage();

    // const customerId = this.navParams.get('customerId');
    
  }

  getToken(data){
    
    if(data){
      this.utils.removeUrlParams();
      this.onValidateToken(data);
    } else {
        console.log('token not received');
    }
    
}

  onValidateToken(token){
    
    this.authenticationService.callValidateToken(token).subscribe(
        (response: any) => {
            if (response && !!response.result) {
                this.error = null;

                this.content.scrollToTop();
                this.customerId = response.payload.customer_id;
                this.phoneNumber = response.payload.phone_number;
                this.token = token;
                this.tokenExpired = false;
                this.tokenResponseCompleted = Promise.resolve(true);
                this.cgd.detectChanges();
            }
        },
        (error) => {
            switch (error.getErrorCode().toUpperCase()) {
                case 'INVALID_TOKEN':
                    error.setErrorMessage('The token provided is invalid');
                    break;
                case "TOKEN_EXPIRED":
                    error.setErrorMessage('The token provided is expired');
                    break;
            }
            this.error = error;
            this.tokenExpired = true;
            this.tokenResponseCompleted = Promise.resolve(true);
            this.content.scrollToTop(10);
            this.cgd.detectChanges();
        }
    );
}

  closeModal = () => {
      this.navigator.dismiss();
      return this.logoutService.onLogout();
  };

  goToUpdatePhoneNumber() {
    // This is a stub, can not update phone number here
  }

  onValidatePinError(event) {
    this.error = event;
    if (this.error) {
      this.content.scrollToTop(10);
    }
  }

  onUpdatePhoneNumber() {
    this.goToUpdatePhoneNumber();
  }

  onValidatePinSuccess() {

    
    //////////////////////////////////////
    // Move to next step of reset password
    //////////////////////////////////////
    
    // this.verifiedCode = true;
    // this.error = null;
    // const uniqueIDService = this.uniqueIDService;
    // const mfcDeviceIdObservable = uniqueIDService.getMFADeviceIdObservable();
    // if (mfcDeviceIdObservable) {
    //   mfcDeviceIdObservable.subscribe(deviceId => {
    //       uniqueIDService.setMFADeviceId(deviceId);
    //     })
    //     .unsubscribe();
    // }
    // this.userSessionService.setMFAStatus(eMfaStatuses.passed);
    // if(this.bypassPinSuccessUI) {
    //   this.validateUserAction();
    // }
  }

  onPinVerifiedUserAction() {
   this.navigator.navigateTo("ResetPasswordMFASecondStepComponent",{},{"token": this.token, "customerId": this.customerId}); 
  }
}
